import styles from './BackgroundContainer.module.css';

export type BorderColor =
    | 'red'
    | 'blue'
    | 'green'
    | 'yellow'
    | 'purple'
    | 'pink'
    | 'indigo'
    | 'cyan'
    | 'orange'
    | 'teal';

// Map border color names to CSS module class names
const borderColorMap: Record<BorderColor, string> = {
    red: styles.borderRed,
    blue: styles.borderBlue,
    green: styles.borderGreen,
    yellow: styles.borderYellow,
    purple: styles.borderPurple,
    pink: styles.borderPink,
    indigo: styles.borderIndigo,
    cyan: styles.borderCyan,
    orange: styles.borderOrange,
    teal: styles.borderTeal,
};

const BackgroundContainer = ({
    className,
    borderColor,
    children,
}: {
    className?: string;
    borderColor?: BorderColor;
    children: React.ReactNode;
}) => {
    const borderColorClass = borderColor ? borderColorMap[borderColor] : '';

    return (
        <div
            className={`${styles.container} ${borderColorClass} ${
                className ?? ''
            }`}
        >
            {children}
        </div>
    );
};

export default BackgroundContainer;
